import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, map, Observable, take, tap } from 'rxjs';
import { DocksModel } from '../../models/DocksModel';
import { httpOptions } from '../../global/global_variables';
import { TimeTableInterface, TimeTableModel } from '../../models/TimeTableModel';
import { QueueTableModel } from '../../models/QueueTable.Model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QueuesService {

  constructor(private http: HttpClient) { }


  listAllDocks() {
    return this.http.get<{ expeditionDocks: DocksModel[] }>(`${environment.apiLink}/View/GetExpeditionDocks`).pipe(take(1));
  }

  getDockDetails() {
    return this.listAllDocks()
      .pipe(
        map((response) => {
          const docks = response.expeditionDocks;
          return docks
        })
      );
  }

  getDockDescriptionsById(dockNumber: number): Observable<string> {
    return this.listAllDocks()
      .pipe(
        map((response) => {
          const dock = response.expeditionDocks.find(d => d.id == dockNumber)
          return dock?.description!
        })
      );
  }

  listAvailableTrips() {
    return this.http.get<{ tripsInQueue: TimeTableInterface[] }>(`${environment.apiLink}/Queues/GetTrips/?filter=Unlinked`, httpOptions)
      .pipe(
        map((response) => response.tripsInQueue),
        take(1))
  }

  listLinkedTrips() {
    return this.http.get<{ tripsInQueue: TimeTableModel[] }>(`${environment.apiLink}/Queues/GetTrips/?filter=Linked`, httpOptions)
      .pipe(
        tap((response) => console.log(response)),
        take(1))
  }

  listQueueByDockNumber(dockNumber: number) {
    return this.http.get<{ tripsInQueue: QueueTableModel[] }>(`${environment.apiLink}/Queues/GetTrips?dockId=${dockNumber}`, httpOptions);
  }

  linkTripOnDock(dockNumber: number, tripNumber: number) {
    return this.http.put(`${environment.apiLink}/Queues/LinkDock/${dockNumber}/ToTrip/${tripNumber}`, null, httpOptions)
  }

  getTripDetailsByNumber(tripNumber: number): Observable<TimeTableInterface> {
    return this.http.get<{ timeTable: TimeTableInterface[] }>(`${environment.apiLink}/TimeTable/GetByViagem/${tripNumber}`, httpOptions)
      .pipe(
        tap(response => console.log(response)),
        map(response => response.timeTable[0]),
        take(1)
      );
  }

  deleteTripFromDock(tripNumber: number) {
    return this.http.put<TimeTableModel>(`${environment.apiLink}/Queues/UnlinkTrip/${tripNumber}`, tripNumber, httpOptions)
      .pipe(first());
  }

  updateQueueOrder(dockId: number, tripNumber: number, action: "up" | "down"): Observable<any> {
    const payload = { dockId, tripNumber, action };
    return this.http.put(`${environment.apiLink}/Queues/UpdateQueueOrder`, payload, httpOptions);
  }

  recalculateQueueOrder(dockId: number): Observable<any> {
    return this.http.put(`${environment.apiLink}/Queues/RecalculateOrder/${dockId}`, httpOptions);
  }


}
